import { render, staticRenderFns } from "./CaseDetails.vue?vue&type=template&id=443069c9"
import script from "./CaseDetails.vue?vue&type=script&lang=js"
export * from "./CaseDetails.vue?vue&type=script&lang=js"
import style0 from "./CaseDetails.vue?vue&type=style&index=0&id=443069c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports